import styled from 'styled-components'

import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { MenuBox } from '@chegg-wt/core/theme/sunkist/menu'
import {
  ListContainer as FListContainer,
  FullSizedAction as FFullSizedAction,
} from '@chegg-wt/core/components/Folders/styled'
import { SecondaryLink } from '@chegg-wt/core/theme/sunkist/link'

export const SettingAction = styled(FFullSizedAction)`
  ${SecondaryLink};
`

export const SettingsMenuItem = styled.li``

export const SettingsMenu = styled(FListContainer)`
  ${MenuBox};
  padding: ${values.small};

  & > * + * {
    margin-top: ${values.small};
  }
`
